import {ChipProps, ChipStyle} from "./chip.style";
import React, {memo, ReactNode} from "react";

interface ChipComponentProps extends React.HTMLAttributes<HTMLDivElement>, Omit<ChipProps, "$hasIcon"> {
    children?: ReactNode;
    icon?: ReactNode
}

export const ChipComponent = memo(({children, icon, ...props}: ChipComponentProps) => {
    return (
        <ChipStyle className={`whitespace-nowrap select-none rb-chip ${props.className}`} {...props} $hasIcon={!!icon} {...props}>
            {icon && <div className={"icon"}>{icon}</div>}
            <span>
            {children}
            </span>
        </ChipStyle>
    )
})